
import { Component, Vue, Emit } from "vue-property-decorator";
import { SweetModal } from "sweet-modal-vue";
import { translate } from "@/helpers/functions";

// Define reusable type for your stays filter
type StayStatuses = "active" | "upcoming" | "past";

@Component({
  methods: { translate },
  components: { SweetModal },
})
export default class StaySearchFilter extends Vue {
  /** Available statuses **/
  filter: { stays: Record<StayStatuses, string> } = {
    stays: {
      active: "active",
      upcoming: "upcoming",
      past: "past",
    },
  };

  /** Selected statuses **/
  selectedStatus: Record<StayStatuses, boolean> = {
    active: false,
    upcoming: false,
    past: false,
  };

  mounted() {
    this.$root.$on("clear-filters", this.resetFilters);
  }

  beforeDestroy() {
    this.$root.$off("clear-filters", this.resetFilters);
  }

  /** Emit both query + attributes */
  @Emit("apply-filter")
  emitFilter(payload: { query: string; attributes: Record<string, any> }) {
    return payload;
  }

  /** Submit filters **/
  onSubmit() {
    const selectedStatuses = (Object.keys(this.selectedStatus) as StayStatuses[]).filter(
      (k) => this.selectedStatus[k]
    );

    const attributes = {
      status: selectedStatuses.map((k) => ({
        value: this.filter.stays[k],
        translatable: true,
      })),
    };

    const query = selectedStatuses.length
      ? selectedStatuses.map((k) => `status[]=${k}`).join("&")
      : "";

    this.emitFilter({ query, attributes });
    this.cancel();
  }

  /** Clear filters manually **/
  onClear() {
    this.resetFilters();
    this.emitFilter({ query: "", attributes: { status: [] } });
  }

  /** Reset all filters **/
  resetFilters() {
    (Object.keys(this.selectedStatus) as StayStatuses[]).forEach((k) => {
      this.selectedStatus[k] = false;
    });
  }

  /** Close modal **/
  cancel() {
    const modal = this.$refs.create as InstanceType<typeof SweetModal> | undefined;
    modal?.close();
  }
}
